import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Tr,
} from "@chakra-ui/react";
import { FiEdit, FiEye, FiSearch, FiTrash } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import { get_product_list } from "../../redux/productSlice";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/utils";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const Products = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");

  // Get page and rows from URL params, with defaults
  const urlPage = parseInt(searchParams.get("page")) || 1;
  const urlRows = parseInt(searchParams.get("rows")) || 10;

  const [rows, setRows] = useState(urlRows);
  const [page, setPage] = useState(urlPage);
  const [initialValue, setInitialValue] = useState(
    (urlPage - 1) * urlRows + 1
  );
  const [deleteId, setDeleteId] = useState(null); 

  const { product_list, total_product_count,loading } = useSelector(
    (state) => state.products
  );

  console.log(product_list,"prod")

  const [filteredProducts, setFilteredProducts] = useState([]);

  // Update URL when page or rows change
  const updateURL = (newPage, newRows) => {
    const params = new URLSearchParams();
    params.set("page", newPage.toString());
    params.set("rows", newRows.toString());
    setSearchParams(params);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `product.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_product_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Load data based on URL parameters
    store.dispatch(get_product_list({ page: page, rows: rows }));
  }, [page, rows]);

  // Update filtered list whenever product list or search term changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredProducts(product_list);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      const filtered = product_list.filter(
        (el) =>
          el?.description?.toLowerCase().includes(lowerSearch) ||
          el?.category?.toLowerCase().includes(lowerSearch) ||
          el?.type?.toLowerCase().includes(lowerSearch)
      );
      setFilteredProducts(filtered);
    }
  }, [searchTerm, product_list]);

  // Navigate to product detail page with current page context
  const viewProductDetails = (productId) => {
    navigate(`/products/${productId}?returnPage=${page}&returnRows=${rows}`);
  };

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl">Products</Heading>
        <Flex direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap">
  <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "sm"]}>
          <Input
            placeholder="Search by type, name, or category..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <InputRightElement>
            <FiSearch />
          </InputRightElement>
        </InputGroup>

        <CustomButton
          title="Add Product"
          onClick={() => navigate("/products/add-product")}
          w={["100%", "auto"]}
        />
        </Flex>
        
      </Card>

      <div>
  {loading ? (
    <GasCylinderLoader 
    size="sm"
    loadingText="Loading Products"
    />
  ) : (
    <TableView
      headData={[
        "S.No.",
        "Description",
        "Category",
        "Type",
        "Capacity",
        "Action",
      ]}
      body={filteredProducts.map((el, i) => (
        <Tr key={el.id}>
          <Td textAlign="center">{i + initialValue}</Td>
          <Td textAlign="center">{el.description}</Td>
          <Td textAlign="center">{el.category}</Td>
          <Td textAlign="center">{el.type}</Td>
          <Td textAlign="center">{el.capacity}</Td>
          <Td textAlign="center">
            <Flex justify="center" gap={4}>
              <CustomToolTip
                button={
                  <FiEye
                    size={20}
                    color="#0175c2"
                    cursor="pointer"
                    onClick={() => viewProductDetails(el.id)}
                  />
                }
                mess="View Product"
              />
              <CustomToolTip
                button={
                  <FiEdit
                    size={20}
                    cursor="pointer"
                    onClick={() =>
                      navigate(
                        `/products/edit/${el.id}?returnPage=${page}&returnRows=${rows}`
                      )
                    }
                  />
                }
                mess="Edit Product"
              />
              <CustomToolTip
                button={
                  <FiTrash
                    size={20}
                    cursor="pointer"
                    color="#F00"
                    onClick={() => {
                      setDeleteId(el.id);
                      setDeleteDialog(true);
                    }}
                  />
                }
                mess="Delete Product"
              />
            </Flex>
          </Td>
        </Tr>
      ))}
      initialValue={initialValue}
      page={page}
      rows={rows}
      total_value={total_product_count}
      pagination
      onChange={(e) => {
        const newRows = parseInt(e.target.value);
        setInitialValue(1);
        setPage(1);
        setRows(newRows);
        updateURL(1, newRows);
        store.dispatch(get_product_list({ page: 1, rows: newRows }));
      }}
      onPrevious={() => {
        if (page > 1) {
          const newPage = page - 1;
          const newInitialValue = (newPage - 1) * rows + 1;
          setInitialValue(newInitialValue);
          setPage(newPage);
          updateURL(newPage, rows);
          store.dispatch(get_product_list({ page: newPage, rows: rows }));
        }
      }}
      onNext={() => {
        if (rows * page < total_product_count) {
          const newPage = page + 1;
          const newInitialValue = (newPage - 1) * rows + 1;
          setInitialValue(newInitialValue);
          setPage(newPage);
          updateURL(newPage, rows);
          store.dispatch(get_product_list({ page: newPage, rows: rows }));
        }
      }}
    />
  )}

  <ConfirmDialog
    isOpen={deleteDialog}
    onClose={() => setDeleteDialog(false)}
    onConfirm={handleDelete}
    type="delete"
    title="Delete Product"
    message="Are you sure you want to delete this product? This action cannot be undone and will remove all associated data."
    confirmText="Delete"
    cancelText="Cancel"
    isLoading={isLoading}
  />
</div>

    </>
  );
};

export default Products;
